import { useNavigate } from 'react-router-dom';
import Typography from '../../sharedComponents/Typography/Typography';
import { GeoSun } from '../../sharedComponents/assets/svg-tsx/sensible';
import DashboardIcon from './DashboardIcon';
import styles from './home-authed.module.scss';

type AccountSummaryHeroProps = {
  greeting: string;
  firstName: string;
  coveredTripsCount: number;
  activeClaimsCount: number;
  openClaimsCount: number;
};

const AccountSummaryHero: React.FC<AccountSummaryHeroProps> = ({
  greeting,
  firstName,
  coveredTripsCount,
  activeClaimsCount,
  openClaimsCount,
}) => {
  const navigate = useNavigate();

  return (
    <section className={styles.hero} aria-label="Personalized account summary">
      <div className={styles.heroArtwork} aria-hidden="true">
        <GeoSun className={styles.sun} />
        <div className={`${styles.cloud} ${styles.cloudBack}`} />
        <div className={`${styles.cloud} ${styles.cloudFront}`} />
      </div>

      <div className={styles.heroContent}>
        <div className={styles.eyebrow}>
          <span className={styles.eyebrowDot} />
          Sensible Weather home
        </div>
        <Typography variant="h1" className={styles.heroTitle} color="snow">
          {greeting}, {firstName}.
        </Typography>
        <Typography
          variant="body-2"
          className={styles.heroDescription}
          color="snow"
        >
          Your Weather Guarantees, reimbursements, and travel details—all in one
          sunny spot.
        </Typography>
      </div>

      <div className={styles.statusBar}>
        <button
          type="button"
          className={styles.statusMessage}
          onClick={() => navigate('/trips')}
        >
          <span
            className={`${styles.statusIcon} ${
              openClaimsCount ? styles.statusIconAttention : ''
            }`}
          >
            <DashboardIcon name={openClaimsCount ? 'arrow' : 'check'} />
          </span>
          <span className={styles.statusCopy}>
            <Typography variant="label-1" color="snow">
              {openClaimsCount
                ? `${openClaimsCount} reimbursement${
                    openClaimsCount === 1 ? '' : 's'
                  } to review`
                : 'Clear skies!'}
            </Typography>
            <Typography
              variant="body-4"
              className={styles.statusSupportingText}
              color="snow"
            >
              {openClaimsCount
                ? 'Open your trips to claim your reimbursement.'
                : 'You have no reimbursements at this time'}
            </Typography>
          </span>
        </button>

        <div className={styles.heroStats} aria-label="Coverage summary">
          <div>
            <strong>{coveredTripsCount}</strong>
            <span>upcoming coverages</span>
          </div>
          <div>
            <strong>{activeClaimsCount}</strong>
            <span>active reimbursements</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccountSummaryHero;
